import immutable from 'object-path-immutable';
import React, { Component } from 'react';
import { Badge, Col, Row } from 'react-bootstrap';
import SweetAlert from 'react-bootstrap-sweetalert';
import { connect } from 'react-redux';
import ActionsBar from '../../../components/ActionsBar';
import Button from '../../../components/CustomButton/CustomButton';
import OperatorsName from '../../../components/OperatorsName/OperatorsName';

import * as K from '../redux/SalesConstants';

class otherServicesSale extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openConfirm: false,
      indexToDelete: 0,
    };
  }

  handleEdit = (index) => {
    var newSale = immutable.set(this.props.Sales, ['indexToEdit'], index);
    newSale = immutable.set(
      newSale,
      ['dataToEdit', 'otherServices'],
      this.props.Sales.otherServicesSale[index]
    );

    this.props.dispatch({
      type: K.SETSTATE,
      payload: newSale,
    });

    this.props.dispatch({
      type: K.OPEN_MODAL_ADD,
      payload: 'otherServices',
    });
  };

  handleDelete(confirm = false, index) {
    if (confirm) {
      var newArray = immutable.del(this.props.Sales, [
        'otherServicesSale',
        this.state.indexToDelete,
      ]);
      this.props.dispatch({
        type: K.SETSTATE,
        payload: newArray,
      });
      this.setState({ openConfirm: false });
    } else {
      this.setState({ openConfirm: true, indexToDelete: index });
    }
  }

  handleAdd = () => {
    this.props.dispatch({
      type: K.OPEN_MODAL_ADD,
      payload: 'otherServices',
    });
  };

  render() {
    const {
      Sales: {
        otherServicesSale,
        salesInformation: { isPackage = false },
      },
    } = this.props;
    const { openConfirm } = this.state;

    return (
      <div style={{ textAlign: 'justify' }}>
        <Row>
          <Col md={12}>
            {otherServicesSale.map((service, index) => {
              return (
                <div key={index} style={{ marginBottom: '30px' }}>
                  {openConfirm && (
                    <SweetAlert
                      warning
                      style={{ display: 'block', marginTop: '-100px' }}
                      title="¿Estás Seguro?"
                      onConfirm={() => this.handleDelete(true)}
                      onCancel={() => this.setState({ openConfirm: false })}
                      confirmBtnBsStyle="info"
                      cancelBtnBsStyle="danger"
                      confirmBtnText="Si, borrar!"
                      cancelBtnText="Cancelar"
                      showCancel
                    >
                      No podrás deshacer está opción!
                    </SweetAlert>
                  )}
                  <ActionsBar
                    onEdit={() => this.handleEdit(index)}
                    onDelete={() => this.handleDelete(false, index)}
                  />
                  <br />
                  <Row>
                    <Col md={3}>
                      <div className="form-group">
                        <label style={{ fontWeight: 'bold' }} htmlFor="client">
                          NOMBRE
                        </label>
                        <br />
                        <span>{service.name}</span>
                      </div>
                    </Col>
                    <Col md={9}>
                      <div className="form-group">
                        <label style={{ fontWeight: 'bold' }} htmlFor="client">
                          DESCRIPCIÓN
                        </label>
                        <br />
                        <span>{service.description}</span>
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    {!isPackage && (
                      <React.Fragment>
                        <Col md={3}>
                          <div className="form-group">
                            <label
                              style={{ fontWeight: 'bold' }}
                              htmlFor="client"
                            >
                              COSTO DE COMPRA
                            </label>
                            <br />
                            <Badge style={{ backgroundColor: '#5FB404' }}>
                              {'   $ '}
                              {service.buyprice}
                            </Badge>
                          </div>
                        </Col>
                        <Col md={3}>
                          <div className="form-group">
                            <label
                              style={{ fontWeight: 'bold' }}
                              htmlFor="client"
                            >
                              PRECIO DE VENTA
                            </label>
                            <br />
                            <Badge style={{ backgroundColor: '#0489B1' }}>
                              {'   $ '}
                              {service.price}
                            </Badge>
                          </div>
                        </Col>
                      </React.Fragment>
                    )}
                    <Col md={3}>
                      <div className="form-group">
                        <label style={{ fontWeight: 'bold' }} htmlFor="client">
                          OPERADOR
                        </label>
                        <br />
                        <OperatorsName id={service.operator} />
                      </div>
                    </Col>
                  </Row>
                </div>
              );
            })}
          </Col>
        </Row>
        <Button bsStyle="primary" onClick={this.handleAdd}>
          Agregar Servicio
        </Button>
      </div>
    );
  }
}

export default connect((state) => ({ Sales: state.Sales }))(otherServicesSale);



// WEBPACK FOOTER //
// ./src/views/Sales/cardsSale/otherServicesSale.js